import { HopePepe_Contract_ABI, HopePepe_Contract_Address, USDC_Contract_Abi, USDC_Contract_Address, USDT_Contract_Abi, USDT_Contract_Address, WBTC_Contract_Abi, WBTC_Contract_Address } from "../utilies/constant";
import useGetAmountOut from "./useGetAmountOut";


const useTokenBalances = (fromValue,toValue, address) => {
  const { tokenBlnc: USDTBalance } = useGetAmountOut(
    USDT_Contract_Address,
    USDT_Contract_Abi,
    fromValue,
    "balanceOf",
    [address]
  );

  const { tokenBlnc: USDCBalance } = useGetAmountOut(
    USDC_Contract_Address,
    USDC_Contract_Abi,
    fromValue,
    "balanceOf",
    [address]
  );

  const { tokenBlnc: HOPEBalance } = useGetAmountOut(
    HopePepe_Contract_Address,
    HopePepe_Contract_ABI,
    fromValue,
    "balanceOf",
    [address]
  );

  const { tokenBlnc: WBTCBalance } = useGetAmountOut(
    WBTC_Contract_Address,
    WBTC_Contract_Abi,
    fromValue,
    "balanceOf",
    [address]
  );

  return { USDTBalance, USDCBalance, HOPEBalance,WBTCBalance };
};

export default useTokenBalances;
